module.exports = __webpack_public_path__ + "img/42.f4d80484.jpg";